import { Injectable } from '@angular/core';
import { PortalProduct } from './models/portal-product.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface PortalProductsState extends EntityState<PortalProduct> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'portal-products', idKey: 'ProductId' })
export class PortalProductsStore extends EntityStore<PortalProductsState> {

  constructor() {
    super();
  }

}

